import { render, staticRenderFns } from "./FileUploadComp.vue?vue&type=template&id=3b486c1d&scoped=true&"
import script from "./FileUploadComp.vue?vue&type=script&lang=ts&"
export * from "./FileUploadComp.vue?vue&type=script&lang=ts&"
import style0 from "./FileUploadComp.vue?vue&type=style&index=0&id=3b486c1d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b486c1d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFileInput } from 'vuetify/lib/components/VFileInput';
installComponents(component, {VFileInput})
